import { Badge } from '../../Badge/Badge';
import type { BadgeColor } from '../../Badge/Badge.types';
import { useAdvancesTranslation } from './i18n';
import type { AdvanceApplicationStatus } from './types';

/** Mapeo estado → color de Badge (§4.3). */
const STATUS_COLOR: Record<AdvanceApplicationStatus, BadgeColor> = {
  RESERVED: 'blue',
  CONFIRMED: 'green',
  REVERSED: 'zinc',
};

/** Mapeo estado → clave i18n de la etiqueta. */
const STATUS_LABEL_KEY: Record<AdvanceApplicationStatus, string> = {
  RESERVED: 'advances.status.reserved',
  CONFIRMED: 'advances.status.confirmed',
  REVERSED: 'advances.status.reversed',
};

export interface AdvanceStatusBadgeProps {
  status: AdvanceApplicationStatus;
  /** Etiqueta provista por el backend (`statusLabel`); tiene prioridad si existe. */
  statusLabel?: string | null;
  /** Texto del tooltip (fecha correspondiente al estado). */
  tooltip?: string;
}

/**
 * Badge de estado de una aplicación de anticipo.
 *
 * Reutiliza el componente `Badge` del kit (que ya incluye dark mode por tokens).
 * Colores: RESERVED azul, CONFIRMED verde, REVERSED gris (§4.3 / CA-F2).
 */
export function AdvanceStatusBadge({ status, statusLabel, tooltip }: AdvanceStatusBadgeProps) {
  const { t } = useAdvancesTranslation();
  const label = statusLabel?.trim() || t(STATUS_LABEL_KEY[status]);

  return <Badge color={STATUS_COLOR[status]} label={label} title={tooltip} />;
}
